/*
 * action types
 */

import {
  SCOREBOARD_BOTTOM_SWITCH_SLIDE,
  SCOREBOARD_BOTTOM_UPDATE_SLIDES,
  SCOREBOARD_TOP_UPDATE_SLIDES,
  SCOREBOARD_TOP_SWITCH_SLIDE,
  SCOREBOARD_START,
  SCOREBOARD_STOP,
  STATSLIDES_SWITCH_SLIDE,
  STATSLIDES_UPDATE_SLIDES,
  BS_ADD_PROCESSING_EVENT,
  BS_RESET_TO_INITIAL_STATE,
  BS_SHOW_PROCESSING_EVENT,
  BS_HIDE_PROCESSING_EVENT,
  BS_REMOVE_PROCESSING_EVENT,
  BS_INITIAL_WAIT_OVER,
} from 'constants/actions';

/*
 * action creators
 */

export function startScoreboard() {
  return {
    type: SCOREBOARD_START,
  };
}

export function stopScoreboard() {
  return {
    type: SCOREBOARD_STOP,
  };
}

export function switchScorboardBottom(idx) {
  return {
    type: SCOREBOARD_BOTTOM_SWITCH_SLIDE,
    payload: idx,
  };
}

export function updateScorboardBottom(slides) {
  return {
    type: SCOREBOARD_BOTTOM_UPDATE_SLIDES,
    payload: slides,
  };
}

export function switchScorboardTop(idx) {
  return {
    type: SCOREBOARD_TOP_SWITCH_SLIDE,
    payload: idx,
  };
}

export function updateScorboardTop(slides) {
  return {
    type: SCOREBOARD_TOP_UPDATE_SLIDES,
    payload: slides,
  };
}

export function switchStatSlide(idx) {
  return {
    type: STATSLIDES_SWITCH_SLIDE,
    payload: idx,
  };
}

export function updateStatSlide(slides) {
  return {
    type: STATSLIDES_UPDATE_SLIDES,
    payload: slides,
  };
}

export function bettingSuggestionsAddProcessingEvent(event) {
  return {
    type: BS_ADD_PROCESSING_EVENT,
    payload: event,
  };
}

export function bettingSuggestionsShowProcessingEvent() {
  return {
    type: BS_SHOW_PROCESSING_EVENT,
  };
}

export function bettingSuggestionsHideProcessingEvent() {
  return {
    type: BS_HIDE_PROCESSING_EVENT,
  };
}

export function bettingSuggestionsResetToInitialState() {
  return {
    type: BS_RESET_TO_INITIAL_STATE,
  };
}

export function bettingSuggestionsInitialWaitOver() {
  return {
    type: BS_INITIAL_WAIT_OVER,
  };
}

export function bettingSuggestionsRemoveProcessingEvent() {
  return {
    type: BS_REMOVE_PROCESSING_EVENT,
  };
}
